<template>
    <div style="line-height: 0px;">
        <el-form :inline="true" style="text-align: center;">
            <el-form-item>
                <el-input
                        v-model="searchForm.modulelocation"
                        placeholder="元素名称"
                        clearable
                >
                </el-input>
            </el-form-item>
            <el-form-item>
                <el-button @click="getElesList">搜索</el-button>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="dialogVisible = true">新增</el-button>
            </el-form-item>
            <el-form-item>
                <el-popconfirm title="确定要批量删除数据吗？" @confirm="delHandle(null)">
                    <el-button type="danger" slot="reference" :disabled="delBtlStatu">批量删除</el-button>
                </el-popconfirm>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="getElesList()">刷新</el-button>
            </el-form-item>
        </el-form>
        <el-table
                ref="multipleTable"
                :data="tableData"
                tooltip-effect="dark"
                style="width: 100%"
                :height='700'
                border
                stripe
                :header-cell-style="{background:'#eef1f6',color:'#606266'}"
                @selection-change="handleSelectionChange">
            <el-table-column
                    type="selection"
                    width="55">
            </el-table-column>
            <el-table-column
                    prop="modulelocation"
                    label="模版名称"
                    width="120"
                    >
            </el-table-column>
            <el-table-column
                    prop="elementname"
                    label="元素名称"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="locationtype"
                    label="元素定位方式"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="locationvalue"
                    label="元素定位值"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="operationtype"
                    label="操作元素方式"
                    show-overflow-tooltip>
                <template slot-scope="scope">
                    <p size="small" v-if="scope.row.operationtype === 'sendKeys'" >输入</p>
                    <p size="small" v-if="scope.row.operationtype === 'click'" >点击</p>
                    <p size="small" v-if="scope.row.operationtype === 'clear'" >清除</p>
                    <p size="small" v-if="scope.row.operationtype === 'switch'" >切换</p>
                    <p size="small" v-if="scope.row.operationtype === 'onRandomClick'" >随机点击</p>
                    <p size="small" v-if="scope.row.operationtype === 'onFormClick'" >表单点击</p>
                    <p size="small" v-if="scope.row.operationtype === 'onMoveDowClick'" >移动到元素并点击</p>
                    <p size="small" v-if="scope.row.operationtype === 'openWindows'" >打开新窗口</p>
                    <p size="small" v-if="scope.row.operationtype === 'onAssertionText'" >检查元素值</p>
                </template>
            </el-table-column>
            <el-table-column
                    prop="datatype"
                    label="预期结果"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="elementdesc"
                    label="实际结果"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="statu"
                    label="启用状态">
                <template slot-scope="scope">
                    <el-tag size="small" v-if="scope.row.statu === 1" type="success">启用</el-tag>
                    <el-tag size="small" v-else-if="scope.row.statu === 0" type="danger">禁用</el-tag>
                </template>
            </el-table-column>
            <el-table-column
                    prop="icon"
                    label="操作">
                <template slot-scope="scope">
                    <el-button type="text" @click="editHandle(scope.row.id)">编辑</el-button>
                    <el-divider direction="vertical"></el-divider>
                    <template>
                        <el-popconfirm title="确定删除这条数据吗？" @confirm="delHandle(scope.row.id)">
                            <el-button type="text" slot="reference">删除</el-button>
                        </el-popconfirm>
                    </template>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                layout="total, sizes, prev, pager, next, jumper"
                :page-sizes="[10, 20, 50, 100]"
                :current-page="current"
                :page-size="size"
                :total="total">
        </el-pagination>
        <!--新增对话框-->
        <el-dialog
                title="新增/编辑元素"
                :visible.sync="dialogVisible"
                width="50%"
                top="1%"
                :destroy-on-close="true"
                :before-close="handleClose"
                :close-on-click-modal="false">
            <el-form :model="editForm" :rules="editFormRules" ref="editForm" label-width="100px" class="demo-editForm">
                <el-form-item label="模块名称：" prop="modulelocation" label-width="200px">
                    <el-input v-model="editForm.modulelocation" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="元素名称：" prop="elementname" label-width="200px">
                    <el-input v-model="editForm.elementname" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="元素定位方式：" prop="locationtype" label-width="200px">
                    <el-select v-model="editForm.locationtype" clearable placeholder="请选择元素定位方式">
                        <el-option
                                v-for="item in locationTypeAll"
                                :key="item.value"
                                :label="item.label"
                                :value="item.label">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="元素定位值：" prop="locationvalue" label-width="200px">
                    <el-input v-model="editForm.locationvalue" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="操作元素方式：" prop="operationtype" label-width="200px">
                    <el-select v-model="editForm.operationtype" clearable placeholder="请选择操作元素方式">
                        <el-option
                                v-for="item in operationTypeAll"
                                :key="item.label"
                                :label="item.label"
                                :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="预期结果：" prop="datatype" label-width="200px">
                    <el-input v-model="editForm.datatype" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="实际结果：" prop="elementdesc" label-width="200px">
                    <el-input v-model="editForm.elementdesc" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="元素状态：" prop="statu" label-width="200px">
                    <el-radio-group v-model="editForm.statu">
                        <el-radio :label=0>禁用</el-radio>
                        <el-radio :label=1>启用</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="遍历：" prop="ergodic" label-width="200px">
                    <el-radio-group v-model="editForm.ergodic">
                        <el-radio :label=0>不遍历时使用</el-radio>
                        <el-radio :label=1>遍历时使用</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="开启该元素相关的测试案例：" prop="opentestallcond" label-width="200px">
                    <el-radio-group v-model="editForm.opentestallcond">
                        <el-radio :label=0>是</el-radio>
                        <el-radio :label=1>否</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="当前步骤开启检测：" prop="startDetectionStep" label-width="200px">
                    <el-radio-group v-model="editForm.startDetectionStep">
                        <el-radio :label=0>是</el-radio>
                        <el-radio :label=1>否</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="submitForm('editForm')">立即创建</el-button>
                    <el-button @click="resetForm('editForm')">重置</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        name: 'Eles',
        data () {
            return {
                locationTypeAll: [{
                    value: 'id',
                    label: 'id'
                },
                {
                    value: 'name',
                    label: 'name'
                },
                {
                    value: 'cssSelector',
                    label: 'cssSelector'
                },
                {
                    value: 'xpath',
                    label: 'xpath'
                },
                {
                    value: 'switch',
                    label: 'switch'
                },
                {
                    value: 'openWindows',
                    label: 'openWindows'
                }],
                operationTypeAll: [{
                    value: 'sendKeys',
                    label: '输入'
                },
                {
                    value: 'click',
                    label: '点击'
                },
                {
                    value: 'clear',
                    label: '清除'
                },
                {
                    value: 'switch',
                    label: '切换'
                },
                {
                    value: 'onRandomClick',
                    label: '随机点击'
                },
                {
                    value: 'onFormClick',
                    label: '循环点击表单'
                },
                {
                    value: 'onMoveDownward',
                    label: '浏览器向下移移动元素悬停'
                },
                {
                    value: 'onMoveDowClick',
                    label: '移动到元素并点击'
                },
                {
                    value: 'openWindows',
                    label: '打开新窗口'
                },
                {
                    value: 'onAssertionText',
                    label: '检查元素值'
                }],
                searchForm: {},
                delBtlStatu: true,
                total: 0,
                size: 10,
                current: 1,
                dialogVisible: false,
                editForm: {
                },
                tableData: [],
                editFormRules: {
                    modulelocation: [
                        {required: true, message: '请输入模块名称', trigger: 'blur'}
                    ],
                    elementname: [
                        {required: true, message: '请输入元素名称', trigger: 'blur'}
                    ],
                    locationtype: [
                        {required: true, message: '请输入元素定位方式', trigger: 'blur'}
                    ],
                    locationvalue: [
                        {required: true, message: '请输入元素定位值', trigger: 'blur'}
                    ],
                    operationtype: [
                        {required: true, message: '请输入操作元素方式', trigger: 'blur'}
                    ],
                    statu: [
                        {required: true, message: '请选择状态', trigger: 'blur'}
                    ],
                    elementdesc: [
                        {required: true, message: '请输入描述', trigger: 'blur'}
                    ]
                },
                multipleSelection: [],
                permDialogVisible: false,
                permForm: {},
                defaultProps: {
                    children: 'children',
                    label: 'name'
                },
                permElesData: []
            }
        },
        created () {
            this.getElesList()
            // this.$axios.get('/ui/eles/list').then(res => {
            //     this.permElesData = res.data.data
            // })
        },
        methods: {
            toggleSelection (rows) {
                if (rows) {
                    rows.forEach(row => {
                        this.$refs.multipleTable.toggleRowSelection(row)
                    })
                } else {
                    this.$refs.multipleTable.clearSelection()
                }
            },
            handleSelectionChange (val) {
                console.log('勾选')
                console.log(val)
                this.multipleSelection = val
                this.delBtlStatu = val.length === 0
            },
            handleSizeChange (val) {
                console.log(`每页 ${val} 条`)
                this.size = val
                this.getElesList()
            },
            handleCurrentChange (val) {
                console.log(`当前页: ${val}`)
                this.current = val
                this.getElesList()
            },
            resetForm (formName) {
                this.$refs[formName].resetFields()
                this.editForm = {}
            },
            handleClose () {
                this.dialogVisible = false
            },
            getElesList () {
                this.$axios.get('/ui/eles/list', {
                    params: {
                        modulelocation: this.searchForm.modulelocation,
                        current: this.current,
                        size: this.size
                    }
                }).then(res => {
                    this.tableData = res.data.data.records
                    console.log(res.data.data.records)
                    this.size = res.data.data.size
                    this.current = res.data.data.current
                    this.total = res.data.data.total
                })
            },
            submitForm (formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.$axios.post('/ui/eles/' + (this.editForm.id ? 'update' : 'save'), this.editForm)
                            .then(res => {
                                this.$message({
                                    showClose: true,
                                    message: '恭喜你，操作成功',
                                    type: 'success',
                                    onClose: () => {
                                        this.getElesList()
                                    }
                                })
                                this.dialogVisible = false
                                this.resetForm(formName)
                            })
                    } else {
                        console.log('error submit!!')
                        return false
                    }
                })
            },
            editHandle (id) {
                console.log(id)
                this.$axios.get('/ui/eles/info/' + id).then(res => {
                    this.editForm = res.data.data
                    this.dialogVisible = true
                })
            },
            delHandle (id) {
                var ids = []
                if (id) {
                    ids.push(id)
                } else {
                    this.multipleSelection.forEach(row => {
                        ids.push(row.id)
                    })
                }
                console.log(ids)
                this.$axios.post('/ui/eles/delete', ids).then(res => {
                    this.$message({
                        showClose: true,
                        message: '恭喜你，操作成功',
                        type: 'success',
                        onClose: () => {
                            this.getElesList()
                        }
                    })
                })
            }
        }
    }
</script>

<style>
    .el-pagination {
        float: right;
        margin-top: 22px;
    }
</style>



// WEBPACK FOOTER //
// src/components/ui/Eles.vue